import { useQuery } from "@apollo/client";
import { GetServerSideProps } from "next";
import { serverSideTranslations } from "next-i18next/serverSideTranslations";
import { useRouter } from "next/dist/client/router";
import React from "react";
import BackButton from "../../components/BackButton";
import Box from "../../components/Box";
import Packages from "../../components/categoryDetail/Packages";
import ShopLayout from "../../components/layouts/ShopLayout";
import Title from "../../components/Title";
import {
  categoryDetailQuery,
  footerQuery,
  headerQuery,
} from "../../graphql/queries";
import {
  CategoryDetailQuery,
  CategoryDetailQueryVariables,
} from "../../graphql/types";
import { getIdFromUrl } from "../../helpers/url";
import { initializeApollo } from "../../libs/apollo-client";

const CategoryPage = () => {
  const { query } = useRouter();
  const id = getIdFromUrl(query.slug);

  const { data } = useQuery<CategoryDetailQuery, CategoryDetailQueryVariables>(
    categoryDetailQuery,
    {
      variables: {
        id: id as string,
      },
    }
  );
  return (
    <ShopLayout title={data?.category?.title}>
      <Box px={3}>
        <BackButton />
        <Title level={1}>{data?.category?.title}</Title>
        <Packages packages={data?.category?.packages} />
      </Box>
    </ShopLayout>
  );
};

export default CategoryPage;

export const getServerSideProps: GetServerSideProps = async ({
  locale,
  query,
}) => {
  const apolloClient = initializeApollo(null, locale);
  await apolloClient.query({
    query: footerQuery,
  });
  const id = getIdFromUrl(query.slug);
  await apolloClient.query({
    query: categoryDetailQuery,
    variables: {
      id,
    },
  });
  await apolloClient.query({
    query: headerQuery,
  });

  return {
    props: {
      initialApolloState: apolloClient.cache.extract(),
      ...(await serverSideTranslations(locale as string, [
        "common",
        "categoryDetail",
      ])),
    },
  };
};
